import { createAction } from "@reduxjs/toolkit";
import type { InternalTrainingVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveInternalTrainings = createApiThunk<InternalTrainingVM[], void>(
  "internalTrainings/retrieveInternalTrainings",
  async (_, { extra: { adminRepository } }) => {
    return adminRepository!.listInternalTrainings();
  },
);

export const resetAdminRetrieveInternalTrainings = createAction("internalTrainings/resetAdminRetrieveInternalTrainings");
